/* RYZE THE FILTER + SORT CONTROLS (W-FACETS 2026-10-18, CC2)
 * SVNTY's svnty-filter.js in RYZE's system. facets.js (Dawn) keeps every
 * mechanism: the fetch, the section re-render by id, pushState, the applied
 * chips, the count, the loading spinner. This script only adds the face:
 * 1. THE HOIST: the sheet and the sort menu move to <body> at boot, out of
 *    every ancestor's stacking context (the header paints at 1000; both doors
 *    sit at 1050, the search door's step).
 * 2. THE FILTER SHEET: one door. Open = unhidden + .is-open + THE LOCK
 *    (window.RYZE.headLock, html.ryze-locked: the sticky bar and the promo pill
 *    step off) + everything else inert + focus inside + Tab trapped. Close =
 *    the X, the scrim, "Show N", Escape; focus returns to FILTER.
 * 3. THE LIVE FACE: after every facets.js render the FILTER badge (the chips
 *    over the grid are the truth), "Show N" and the sheet's count (#ProductCount
 *    [data-ryze-n] is the truth) and each group's value line follow.
 * 4. THE SORT MENU: the house listbox (assets/ryze-sticky-atc.js's size menu):
 *    role=listbox/option, aria-selected, roving focus, Arrow/Home/End, Enter and
 *    Space pick, Escape and an outside press close, a page scroll closes, the
 *    caret turns, down or up as the room allows. A pick writes the hidden
 *    sort_by select inside the one filter form and asks facets.js to render now
 *    (its own onSubmitHandler, no 800 ms debounce for a single choice).
 *    The select is never focused or shown: no iOS picker wheel, ever.
 * 5. Back/forward: facets.js re-renders the grid from history; the select, the
 *    label and the ticks follow the URL here. A remove link keeps the sort.
 * No console, ASCII only.
 */
(function () {
  'use strict';
  /* CODE-26 (2026-10-18): one run per page, whatever loads it twice. */
  if (window.__ryzeFacetsInit) return;
  window.__ryzeFacetsInit = true;
  var root = document.documentElement;
  var bar = document.querySelector('[data-ryze-facets]');
  if (!bar) return;

  function focusQuiet(el) { if (!el || !el.focus) return; try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); } }
  function lock() { if (window.RYZE && window.RYZE.headLock) window.RYZE.headLock.lock(); }
  function unlock() { if (window.RYZE && window.RYZE.headLock) window.RYZE.headLock.unlock(); }
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── 1. THE HOIST ─────────────────────────────────────────── */
  var sheet = bar.querySelector('[data-ryze-filter-sheet]');
  var menu = bar.querySelector('[data-ryze-sort-menu]');
  if (sheet) document.body.appendChild(sheet);
  if (menu) document.body.appendChild(menu);

  var fBtn = bar.querySelector('[data-ryze-filter-open]');
  var sBtn = bar.querySelector('[data-ryze-sort-open]');
  var form = document.getElementById('FacetFiltersForm');
  var select = form ? form.querySelector('[data-ryze-sort-select]') : null;
  var def = bar.getAttribute('data-sort-default') || '';

  /* ── 1b. THE DOCK's mark: a 1 px sentinel before the host; once it passes
     under the header the host carries .is-docked (a hairline, no height change) */
  var host = bar.closest('.ryze-facets-host');
  if (host && 'IntersectionObserver' in window) {
    var sentinel = document.createElement('div');
    sentinel.setAttribute('aria-hidden', 'true');
    sentinel.style.cssText = 'display:block;height:1px;margin-bottom:-1px;pointer-events:none;';   /* inline display: base.css div:empty would hide it */
    host.parentNode.insertBefore(sentinel, host);
    var probe = document.createElement('div');
    probe.style.cssText = 'position:absolute;visibility:hidden;height:var(--ryze-total-header-h, 98px);width:1px;top:0;left:0;';
    document.body.appendChild(probe);
    var headH = probe.offsetHeight || 98;
    probe.remove();
    new IntersectionObserver(function (es) {
      es.forEach(function (en) { host.classList.toggle('is-docked', !en.isIntersecting && en.boundingClientRect.top < headH); });
    }, { rootMargin: '-' + Math.round(headH) + 'px 0px 0px 0px', threshold: 0 }).observe(sentinel);
  }

  /* ── 2. THE FILTER SHEET ──────────────────────────────────── */
  var panel = sheet ? sheet.querySelector('.ryze-fsheet__panel') : null;
  var inerted = [];
  var closeTimer = 0;
  function isOpen() { return !!(sheet && sheet.classList.contains('is-open')); }
  function setInert(on) {
    inerted.forEach(function (el) { el.inert = false; });
    inerted = [];
    if (!on || !('inert' in HTMLElement.prototype)) return;
    Array.prototype.forEach.call(document.body.children, function (el) {
      if (el === sheet || /^(SCRIPT|STYLE|LINK)$/.test(el.tagName) || el.inert) return;
      el.inert = true;
      inerted.push(el);
    });
  }
  function focusables() {
    return Array.prototype.filter.call(
      panel.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), summary, [tabindex="0"]'),
      function (el) { return el.offsetParent !== null || el === document.activeElement; }
    );
  }
  function openSheet() {
    if (!sheet || isOpen()) return;
    closeMenu(false);
    clearTimeout(closeTimer);
    sheet.hidden = false;
    void sheet.offsetWidth;
    sheet.classList.add('is-open');
    fBtn.setAttribute('aria-expanded', 'true');
    lock();
    setInert(true);
    refresh();
    requestAnimationFrame(function () { focusQuiet(panel); });
    document.addEventListener('keydown', onSheetKey, true);
  }
  function closeSheet() {
    if (!isOpen()) return;
    sheet.classList.remove('is-open');
    fBtn.setAttribute('aria-expanded', 'false');
    setInert(false);
    unlock();
    document.removeEventListener('keydown', onSheetKey, true);
    closeTimer = setTimeout(function () { if (!isOpen()) sheet.hidden = true; }, REDUCED ? 0 : 320);
    /* QA2 m2: facets.js re-renders the controls' section after a filter is
       applied, so the cached control can be a detached node; look the live
       one up before handing focus back. */
    focusQuiet(document.querySelector('[data-ryze-filter-open]') || fBtn);
  }
  function onSheetKey(e) {
    if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); closeSheet(); return; }
    if (e.key !== 'Tab') return;
    var list = focusables();
    if (!list.length) return;
    var first = list[0], last = list[list.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) { e.preventDefault(); focusQuiet(last); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); focusQuiet(first); }
    else if (!panel.contains(document.activeElement)) { e.preventDefault(); focusQuiet(first); }
  }
  if (fBtn && sheet && panel) {
    fBtn.addEventListener('click', function () { if (isOpen()) closeSheet(); else openSheet(); });
    sheet.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-ryze-filter-close]')) { e.preventDefault(); closeSheet(); }
    });
  }

  /* ── 3. THE LIVE FACE ─────────────────────────────────────── */
  function countN() {
    var el = document.querySelector('#ProductCount [data-ryze-n]');
    var n = el ? parseInt(el.getAttribute('data-ryze-n'), 10) : NaN;
    return isNaN(n) ? null : n;
  }
  function chipsN() {
    var box = document.querySelector('.active-facets-desktop');
    return box ? box.querySelectorAll('[data-ryze-chip]').length : 0;
  }
  function valueLines() {
    if (!sheet) return;
    Array.prototype.forEach.call(sheet.querySelectorAll('details.js-filter'), function (d) {
      var out = d.querySelector('[data-ryze-fgroup-value]');
      if (!out) return;
      var price = d.querySelectorAll('price-range input');
      var t = '';
      if (price.length === 2) {
        var a = price[0].value.trim(), b = price[1].value.trim();
        if (a || b) t = (a || '0') + ' to ' + (b || price[1].getAttribute('data-max') || '');
      } else {
        t = Array.prototype.map.call(d.querySelectorAll('input[type="checkbox"]:checked'), function (i) { return i.getAttribute('data-label') || i.value; }).join(', ');
      }
      if (out.textContent !== t) out.textContent = t;
    });
  }
  function refresh() {
    var n = countN();
    var c = chipsN();
    if (fBtn) {
      var badge = fBtn.querySelector('[data-ryze-filter-badge]');
      var said = fBtn.querySelector('[data-ryze-filter-said]');
      if (badge) { badge.hidden = c === 0; if (badge.textContent !== String(c)) badge.textContent = String(c); }
      if (said) said.textContent = c === 0 ? '' : (c === 1 ? ', 1 filter on' : ', ' + c + ' filters on');
    }
    if (sheet) {
      var show = sheet.querySelector('[data-ryze-filter-show]');
      var cnt = sheet.querySelector('[data-ryze-fsheet-count]');
      var clr = sheet.querySelector('.ryze-fsheet__clear');
      if (n !== null) {
        var st = n === 1 ? 'Show 1 result' : 'Show ' + n + ' results';
        if (show && show.textContent !== st) show.textContent = st;
        var ct = n === 1 ? '1 fragrance' : n + ' fragrances';
        if (cnt && cnt.textContent !== ct) cnt.textContent = ct;
      }
      if (clr) {
        clr.classList.toggle('is-off', c === 0);
        if (c === 0) clr.setAttribute('aria-disabled', 'true'); else clr.removeAttribute('aria-disabled');
      }
    }
    valueLines();
  }
  var queued = false;
  function refreshSoon() { if (queued) return; queued = true; requestAnimationFrame(function () { queued = false; refresh(); }); }
  if ('MutationObserver' in window) {
    var mo = new MutationObserver(refreshSoon);
    ['ProductCount', 'RyzeFacetsGroups'].forEach(function (id) { var el = document.getElementById(id); if (el) mo.observe(el, { childList: true, subtree: true, characterData: true }); });
    var chipsBox = document.querySelector('.active-facets-desktop');
    if (chipsBox) mo.observe(chipsBox, { childList: true, subtree: true });
  }
  if (form) form.addEventListener('input', refreshSoon);
  /* a quiet Clear all (nothing on) does nothing */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.ryze-fsheet__clear.is-off');
    if (a) { e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);
  refresh();

  /* ── 4. THE SORT MENU ─────────────────────────────────────── */
  var list = menu ? menu.querySelector('[role="listbox"]') : null;
  var label = sBtn ? sBtn.querySelector('[data-ryze-sort-value]') : null;
  function opts() { return list ? Array.prototype.slice.call(list.querySelectorAll('[role="option"]')) : []; }
  function menuOpen() { return !!(menu && menu.classList.contains('is-open')); }
  function rove(o) { opts().forEach(function (x) { x.tabIndex = x === o ? 0 : -1; }); }
  function mark(v) {
    var hit = null;
    opts().forEach(function (o) {
      var on = o.getAttribute('data-value') === v;
      o.setAttribute('aria-selected', on ? 'true' : 'false');
      if (on) hit = o;
    });
    if (hit && label) label.textContent = hit.getAttribute('data-label') || '';
    rove(hit || opts()[0]);
    return hit;
  }
  function gutter() { return window.innerWidth < 750 ? 16 : 24; }
  function place() {
    var r = sBtn.getBoundingClientRect();
    var g = gutter();
    var w = Math.max(Math.round(r.width), 220);
    w = Math.min(w, window.innerWidth - g * 2);
    var left = Math.round(r.right - w);
    left = Math.max(g, Math.min(left, window.innerWidth - g - w));
    menu.style.width = w + 'px';
    menu.style.left = left + 'px';
    list.style.maxHeight = '';
    var h = list.scrollHeight + 2;
    var vh = window.innerHeight;
    var head = document.querySelector('.ryze-header-wrap, .ryze-head, header');
    var ceil = g;
    var cs = getComputedStyle(root).getPropertyValue('--ryze-head-visible-h');
    if (cs && !isNaN(parseFloat(cs))) ceil = Math.max(g, parseFloat(cs) + 8);
    var below = vh - g - Math.round(r.bottom + 8), above = Math.round(r.top - 8) - ceil;
    var up = h > below && (h <= above || above > below);
    menu.toggleAttribute('data-up', up);
    sBtn.toggleAttribute('data-up', up);
    if (up) { menu.style.top = 'auto'; menu.style.bottom = Math.round(vh - (r.top - 8)) + 'px'; }
    else { menu.style.bottom = 'auto'; menu.style.top = Math.round(r.bottom + 8) + 'px'; }
    var room = up ? above : below;
    if (h > room) list.style.maxHeight = Math.max(132, room) + 'px';
  }
  var outsideArmed = false;
  function openMenu() {
    if (!menu || menuOpen()) return;
    menu.hidden = false;
    place();
    void menu.offsetWidth;
    menu.classList.remove('is-closing');
    menu.classList.add('is-open');
    sBtn.setAttribute('aria-expanded', 'true');
    var cur = list.querySelector('[aria-selected="true"]') || opts()[0];
    rove(cur);
    focusQuiet(cur);
    if (list.scrollHeight > list.clientHeight && cur) cur.scrollIntoView({ block: 'nearest' });
    outsideArmed = true;
  }
  function closeMenu(refocus) {
    if (!menuOpen()) return;
    menu.classList.remove('is-open');
    menu.classList.add('is-closing');
    sBtn.setAttribute('aria-expanded', 'false');
    outsideArmed = false;
    setTimeout(function () { if (!menuOpen()) { menu.classList.remove('is-closing'); menu.hidden = true; } }, REDUCED ? 0 : 170);
    if (refocus !== false) focusQuiet(sBtn);
  }
  function apply(v) {
    if (!select) return;
    if (select.value === v) return;
    select.value = v;
    var ff = form.closest('facet-filters-form');
    if (ff && typeof ff.onSubmitHandler === 'function') {
      ff.onSubmitHandler({ preventDefault: function () {}, srcElement: select, target: select });
    } else {
      select.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }
  function pick(o) {
    var v = o.getAttribute('data-value');
    mark(v);
    closeMenu(true);
    apply(v);
  }
  if (sBtn && menu && list) {
    sBtn.addEventListener('click', function () { if (menuOpen()) closeMenu(true); else openMenu(); });
    sBtn.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); openMenu(); }
    });
    list.addEventListener('click', function (e) {
      var o = e.target.closest('[role="option"]');
      if (o) pick(o);
    });
    list.addEventListener('keydown', function (e) {
      var all = opts(), i = all.indexOf(document.activeElement), to = null;
      if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); closeMenu(true); return; }
      if (e.key === 'Tab') { closeMenu(false); return; }
      if (e.key === 'ArrowDown') to = all[(i + 1) % all.length];
      else if (e.key === 'ArrowUp') to = all[(i - 1 + all.length) % all.length];
      else if (e.key === 'Home') to = all[0];
      else if (e.key === 'End') to = all[all.length - 1];
      else if ((e.key === 'Enter' || e.key === ' ') && i >= 0) { e.preventDefault(); pick(all[i]); return; }
      if (to) { e.preventDefault(); rove(to); focusQuiet(to); }
    });
    /* an outside press closes and is swallowed (it never opens the card under it) */
    document.addEventListener('click', function (e) {
      if (!outsideArmed || !menuOpen()) return;
      if (menu.contains(e.target) || sBtn.contains(e.target)) return;
      e.preventDefault();
      e.stopPropagation();
      closeMenu(false);
    }, true);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && menuOpen()) { e.preventDefault(); closeMenu(true); } });
    window.addEventListener('scroll', function () { if (menuOpen()) closeMenu(false); }, { passive: true });
    window.addEventListener('resize', function () { if (menuOpen()) place(); }, { passive: true });
  }

  /* ── 5. history and the remove links ──────────────────────── */
  function syncFromUrl() {
    if (!select) return;
    var v = new URLSearchParams(window.location.search).get('sort_by') || def;
    /* CODE-24 (2026-10-18): the URL value is compared, never spliced into a
       selector (a backslash in sort_by threw a DOMException on popstate). */
    if (v && Array.prototype.some.call(select.options, function (o) { return o.value === v; })) select.value = v;
    mark(select.value);
  }
  window.addEventListener('popstate', function () { setTimeout(syncFromUrl, 0); });
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('facet-remove a[href]');
    if (!a || !select) return;
    try {
      var u = new URL(a.getAttribute('href') || '', window.location.href);
      if (select.value && select.value !== def) u.searchParams.set('sort_by', select.value); else u.searchParams.delete('sort_by');
      a.setAttribute('href', u.pathname + u.search);
    } catch (err) { /* a malformed link renders as it is */ }
  }, true);
  if (select) mark(select.value);
})();
